var render = function render(_c,_vm){return _c('span',{staticClass:"red pending-alert"},[_vm._v("!")])
}
var staticRenderFns = []

export { render, staticRenderFns }